import React, { useEffect, useState } from 'react';

import {
  dataPlanoEntrega,
  headersPlanoEntrega,
  valoresExibidosPlanoEntrega,
} from './auxiliarEntregaFornecedor';
import ItemEntregaPlanoForm from './formPlanoEntrega';
import BoxConteudo from '../../../../../../../components/BoxConteudo';
import CustomButton from '../../../../../../../components/CustomButton';
import CustomCol from '../../../../../../../components/CustomCol';
import CustomRow from '../../../../../../../components/CustomRow';
import OffCanvasFlex from '../../../../../../../components/OffCanvasFlex';
import Tabela from '../../../../../../../components/Tabela';
import theme from '../../../../../../../theme';
import {
  formataNomeMeioSiglas,
  formatarNumero,
  formatarValorFormatoDinheiro,
  formatDate,
  formatDateSimp,
} from '../../../../../../../utils/functions';

type CotacaoType = {
  id: number;
  usuarioId: number;
  entregaId: number;
  observacoes: string;
};

const ItemEntregaPlano: React.FC = () => {
  const [data, setData] = useState<any[]>();

  const offCanvasData =
    data?.map((item) => {
      return {
        id: item.id,
        dataRegistro:
          formatDate(item.dataRegistro) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
        dataUltimaAtualizacao:
          formatDate(item.dataUltimaAtualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),
        dataUltimaVisualizacao:
          formatDate(item.dataUltimaVisualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        separadorLog: '',
        produtoDAF: item.produtoDAF.produtoFarmaceutico,
        valorUnitario: (
          <span style={{ display: 'block', textAlign: 'right' }}>
            {formatarValorFormatoDinheiro(item.valorUnitario)}
          </span>
        ),
        cotacaoDolar: (
          <span style={{ display: 'block', textAlign: 'right' }}>
            {formatarValorFormatoDinheiro(item.cotacaoDolar)}
          </span>
        ),
        dataCotacao: (
          <span style={{ display: 'block', textAlign: 'right' }}>
            {formatDateSimp(item.dataCotacao)}
          </span>
        ),
        qtdCotada: (
          <span style={{ display: 'block', textAlign: 'right' }}>
            {formatarNumero(item.qtdCotada)}
          </span>
        ),
        valorTotal: (
          <span style={{ display: 'block', textAlign: 'right' }}>
            {formatarValorFormatoDinheiro(item.valorTotal)}
          </span>
        ),

        separadorCotacao: '',
        observacoes: item.observacoes,
      };
    }) || [];

  const [showOffCanvas, setShowOffCanvas] = useState(false);
  const handleClickInserirNovo = () => {
    setShowOffCanvas(true); // 🔹 Abre o OffCanvas
  };

  const handleCloseOffCanvas = () => {
    setShowOffCanvas(false); // 🔹 Fecha o OffCanvas
  };

  return (
    <BoxConteudo boxTitulo="Plano de Entregas">
      <CustomRow>
        <CustomCol width="100%">
          <Tabela
            headers={headersPlanoEntrega}
            dataTable={dataPlanoEntrega}
            displayValues={valoresExibidosPlanoEntrega}
            dataOffCanvas={offCanvasData}
            botaoAbrirOffCanvas={false}
            showPagination={false}
            noOffCanvasTable={true}
          />
        </CustomCol>
      </CustomRow>
      <CustomCol className="d-flex justify-content-end">
        <CustomButton
          label="Novo Registro"
          bgColor={theme.colors.botaoAcao.azul}
          textColor={theme.colors.white}
          onClick={() => {
            handleClickInserirNovo();
          }}
        />
      </CustomCol>

      {/* 🔹 OffCanvas de novo registro */}
      <OffCanvasFlex
        show={showOffCanvas}
        onHide={handleCloseOffCanvas}
        tituloCanvas="Nova Entrega"
        style={{ width: '50vw' }}
        botaoAbrir={false}
      >
        {/* Aqui vai o conteúdo do novo registro */}
        <ItemEntregaPlanoForm />
      </OffCanvasFlex>
    </BoxConteudo>
  );
};

export default ItemEntregaPlano;
